import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { premierShippingNotification } from '../analytics'

const bem = new BEMHelper('PremierToastNotification')

export default ({ messages, locale, history, isEIP, tracking, checkoutAnalytics }) => {
    React.useEffect(() => {
        tracking?.trackEvent(premierShippingNotification(checkoutAnalytics, 'impression'))
        return () => {
            tracking?.trackEvent(premierShippingNotification(checkoutAnalytics, 'closed'))
        }
    }, [])

    const onClickHandler = () => {
        window.SF?.dismissToastNotification()
        tracking?.trackEvent(premierShippingNotification(checkoutAnalytics, 'change to premier'))
        history.push(`/${locale.id}/checkout/shipping-options`)
    }
    const messageGroup = isEIP ? messages.paymentStep?.toastNotificationEIP : messages.paymentStep?.toastNotification

    return (
        <div className={bem('container')}>
            <div className={bem('image')} />
            <div className={bem('content')}>
                <div className={bem('text')}>{messageGroup.text()}</div>
                <a className={bem('cta')} onClick={onClickHandler}>
                    {messageGroup.cta()}
                </a>
            </div>
        </div>
    )
}
